var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9996 11.1666C8.14134 11.1666 8.26007 11.1187 8.35579 11.0229C8.45151 10.927 8.49937 10.8083 8.49937 10.6666V7.83326C8.49937 7.6916 8.45144 7.57286 8.35557 7.47702C8.25969 7.38119 8.14089 7.33327 7.99917 7.33327C7.85744 7.33327 7.73871 7.38119 7.64299 7.47702C7.54727 7.57286 7.4994 7.6916 7.4994 7.83326V10.6666C7.4994 10.8083 7.54734 10.927 7.6432 11.0229C7.73908 11.1187 7.85788 11.1666 7.9996 11.1666ZM7.99939 6.19226C8.15195 6.19226 8.27984 6.14066 8.38304 6.03746C8.48624 5.93426 8.53784 5.80637 8.53784 5.65381C8.53784 5.50125 8.48624 5.37337 8.38304 5.27016C8.27984 5.16696 8.15195 5.11536 7.99939 5.11536C7.84682 5.11536 7.71894 5.16696 7.61574 5.27016C7.51254 5.37337 7.46094 5.50125 7.46094 5.65381C7.46094 5.80637 7.51254 5.93426 7.61574 6.03746C7.71894 6.14066 7.84682 6.19226 7.99939 6.19226Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.28eae194503f2745599617c6e06b1e4e.svg";
export { ForwardRef as ReactComponent };